import { render, staticRenderFns } from "./AddToCalendar.vue?vue&type=template&id=085680c1&"
import script from "./AddToCalendar.vue?vue&type=script&lang=js&"
export * from "./AddToCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports